import { ReactElement, useEffect } from 'react';
import { Page } from '@Components/Page';
import { FullPageSpinner } from '@Components/Spinner';

// Tab-level placeholder: triggers the same reload-to-bpm-frontend behavior
// as PlaceholderPage but without wrapping its own <Page>, so it can be
// rendered inside a parent page's tab content without producing two headers.
export const PlaceholderTab = ({
  locationName = 'Tab'
}: {
  locationName?: string;
}): ReactElement => {
  useEffect(() => {
    if (import.meta.env.DEV) {
      console.error(`${locationName} has not yet been migrated from bpm-frontend`);
    } else {
      window.location.reload();
    }
  }, [locationName]);

  return <FullPageSpinner />;
};

export const PlaceholderPage = (): ReactElement => (
  <Page title='' pageType=''>
    <PlaceholderTab locationName='Page' />
  </Page>
);
